"use client"

import { Toaster } from "sonner"

export function ClientToaster() {
   return <Toaster position="bottom-right" richColors />
}
